/**
 * Legal / Company information for Terms and Privacy pages.
 */
export const LEGAL_CONFIG = {
  companyName: 'BND YAZILIM DANIŞMANLIK TİCARET LİMİTED ŞİRKETİ',
  platformName: 'Lezzet Yolda',
  address: 'Seyhan, Adana, Türkiye',
  fullAddress:
    'Site Apartmanı, A Blok D:02, No: 123, Sümer Mahallesi, Şehit Yüzbaşı Bülent Angın Bulvarı, Seyhan, Adana 01150, Türkiye',
  email: 'info@lezzetyolda.com',
  phone: '+90 531 743 01 72',
  mersisNo: '0178185665800001',
  tradeRegistry: '101808',
  taxOffice: 'Ziyapaşa',
  taxNumber: '1781856658',
  website: 'https://lezzetyolda.com',
  lastUpdated: '31 Mart 2026',
} as const;
